import {
  Component,
  DestroyRef,
  Inject,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ToastAlertService } from '@core/services';
import { WorkplaceService } from '../../../services/workplace.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  BusinessService,
  UserService,
  WorkplaceGroupService,
  WorkplaceTypeService,
} from '../../../services';
import { TypeOfJob, WorkPlaceGroup } from '../../../models';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatOptionModule } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { InputComponent } from '@shared/components/input/input.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
@Component({
  selector: 'editMap',
  templateUrl: './edit-job.component.html',
  styles: [
    `
      .green-button {
        background-color: #4caf50;
        color: white;
      }
      .day-checkboxes {
        display: flex;
        justify-content: space-around;
        margin-bottom: 20px; /* Ajusta el margen inferior según sea necesario */
      }

      .checkbox-item {
        font-size: 1.2rem;
        cursor: pointer;
        margin-bottom: 10px; /* Ajusta el espacio entre los checkboxes y el texto según sea necesario */
      }

      .checkbox-item.checked {
        color: #4caf50;
        font-weight: bold;
      }
      .day-checkboxes {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 20px;
      }

      .checkbox-item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .checkbox-item mat-checkbox {
        margin-bottom: 5px;
      }
    `,
  ],
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    InputComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    MatListModule,
    MatCheckboxModule,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
    MatDatepickerModule,
  ],
})
export class EditJobComponent implements OnInit {
  issParking = signal(0);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<EditJobComponent>
  ) {
    this.dialogRef.disableClose = true;
    this.buildForm();
    if (this.data.isparking === '1') {
      this.issParking.set(1);
    }
  }

  private destroyRef = inject(DestroyRef);
  private workplaceService = inject(WorkplaceService);
  private messenger = inject(ToastAlertService);
  private workplaceTypeService = inject(WorkplaceTypeService);
  private workplaceGroupService = inject(WorkplaceGroupService);
  private alertService = inject(ToastAlertService);
  #businessService = inject(BusinessService);
  #WorkerService = inject(UserService);

  formEditJob!: FormGroup;
  workplaceGroups: WorkPlaceGroup[] = [];
  ptypeJobs: TypeOfJob[] = [];

  workerisparking = signal<any[]>([]);

  lunes: boolean = false;
  martes: boolean = false;
  miercoles: boolean = false;
  jueves: boolean = false;
  viernes: boolean = false;
  sabado: boolean = false;
  domingo: boolean = false;

  ngOnInit(): void {
    this.chargueWorkplace();
    this.deshabilitarCamposXY();
    this.chargueTypeJobs();
    this.chargeworkerforparking();
  }

  editJob() {
    this.editWorkplace();
  }

  sumit() {}
  private editWorkplace() {
    if (this.formEditJob.valid) {
      const formData = {
        name: this.formEditJob.value['name'],
        description: this.formEditJob.value['description'],
        phone: this.formEditJob.value['phone'],
        x: this.data.action.x,
        y: this.data.action.y,
        status: this.formEditJob.value['status'],
        workplacetypeid: this.formEditJob.value['workplacetypeid'],
        floorid: this.formEditJob.value['floorid'],
        workplaceGroupId: this.formEditJob.value['workplaceGroupId'],
        monday: this.formEditJob.value['monday'] ? 1 : 0,
        tuesday: this.formEditJob.value['tuesday'] ? 1 : 0,
        wednesday: this.formEditJob.value['wednesday'] ? 1 : 0,
        thursday: this.formEditJob.value['thursday'] ? 1 : 0,
        friday: this.formEditJob.value['friday'] ? 1 : 0,
        saturday: this.formEditJob.value['saturday'] ? 1 : 0,
        sunday: this.formEditJob.value['sunday'] ? 1 : 0,
        assignedWorker: this.formEditJob.value['assignedWorker'],
        startDate: this.convertirFormato(this.formEditJob.value['startDate']),
        endDate: this.convertirFormato(this.formEditJob.value['endDate']),
      };
      if (formData.assignedWorker == null || formData.assignedWorker === '') {
        delete formData.assignedWorker;
      }
      if (formData.startDate == undefined || formData.startDate === '') {
        delete formData.startDate;
      }
      if (formData.endDate == undefined || formData.assignedWorker === '') {
        delete formData.endDate;
      }

      this.workplaceService
        .updateJob(Number(this.data.action.workplaceid), formData)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000) {
              this.dialogRef.close('recargar');
              this.messenger.sucess('Puesto de trabajo actualizado');
            } else {
              this.messenger.error(resp.detail);
            }
          },
        });
    }
  }
  convertirFormato(fecha: Date) {
    if (fecha) {
      // Convertir la cadena de fecha a un objeto Date
      var date = new Date(fecha);

      // Obtener los componentes de la fecha
      var dia = date.getDate();
      var mes = date.getMonth() + 1; // Los meses en JavaScript van de 0 a 11, por eso se suma 1
      var año = date.getFullYear();

      // Formatear la fecha en el formato dd-mm-YYYY
      var fechaFormateada =
        (dia < 10 ? '0' : '') +
        dia +
        '-' +
        (mes < 10 ? '0' : '') +
        mes +
        '-' +
        año;

      return fechaFormateada;
    } else {
      return undefined;
    }
  }

  get id_workplace() {
    return this.formEditJob.get('workplaceid');
  }

  convertirAFecha(fechaStr: string): Date | string {
    if (!fechaStr) {
      return '';
    }

    const parts = fechaStr.split('-'); // Suponiendo que el formato es DD-MM-YYYY
    if (parts.length !== 3) {
      return '';
    }

    const dia = parseInt(parts[0], 10);
    const mes = parseInt(parts[1], 10) - 1; // Los meses en JS son de 0 a 11
    const anio = parseInt(parts[2], 10);

    return new Date(anio, mes, dia);
  }
  filterPhone =
    '^\\+?\\(?[1-9]\\d{0,2}\\)?\\s?\\d{1,4}\\s?\\d{1,4}\\s?\\d{0,4}$';
  private buildForm() {
    console.log(this.data);

    let assignedWorker = '';
    if (this.data.action.parkingAssignmentDTO) {
      const assignedWorkerValue =
        this.data.action.parkingAssignmentDTO.workerId;
      assignedWorker = assignedWorkerValue;
    }

    let startDate;
    if (this.data.action.parkingAssignmentDTO) {
      const assignedWorkerValue = this.convertirAFecha(
        this.data.action.parkingAssignmentDTO.vacancyStartDate
      );

      startDate = assignedWorkerValue;
    } else {
      startDate = '';
    }

    let endDate;
    if (this.data.action.parkingAssignmentDTO) {
      const assignedWorkerValue = this.convertirAFecha(
        this.data.action.parkingAssignmentDTO.vacancyEndDate
      );
      endDate = assignedWorkerValue;
    } else {
      endDate = '';
    }

    // Verifica si assignedWorkerValue es null y asigna '' en su lugar

    const phon = this.data.action.phone.split(' ');
    if (this.data.action.workplaceid) {
      this.formEditJob = this.formBuilder.group({
        workplaceid: [this.data.action.workplaceid, Validators.required],
        name: [this.data.action.name, Validators.required],
        description: [this.data.action.description, Validators.required],
        phone: [this.data.action.phone, Validators.pattern(this.filterPhone)],
        x: [{ value: this.data.action.x, disabled: true }, Validators.required],
        y: [{ value: this.data.action.y, disabled: true }, Validators.required],
        status: [1, Validators.required],
        workplaceGroupId: [
          Number(this.data.action.workplacegroupid),
          Validators.required,
        ],
        workplacetypeid: [
          this.data.action.workplacetypeid,
          Validators.required,
        ],
        floorid: [this.data.idfloor, Validators.required],
        monday: [this.data.action.monday == 1],
        tuesday: [this.data.action.tuesday == 1],
        wednesday: [this.data.action.wednesday == 1],
        thursday: [this.data.action.thursday == 1],
        friday: [this.data.action.friday == 1],
        saturday: [this.data.action.saturday == 1],
        sunday: [this.data.action.sunday == 1],
        assignedWorker: [assignedWorker],
        startDate: [startDate],
        endDate: [endDate],
      });
    }
  }

  deshabilitarCamposXY() {
    this.formEditJob.get('x')?.disable();
    this.formEditJob.get('y')?.disable();
  }

  //*Cargar empleados
  chargeworkerforparking() {
    this.#WorkerService
      .WithOutParking(this.data.businessId, this.data.action.workplaceid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (resp: any) => {
          if (resp.code === 10000) {
            resp.reply.unshift({
              firstName: '',
              lastName: 'Seleccione',
              workerId: null,
            });
            this.workerisparking.set(resp.reply);
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  //*grupo de Tipos de puestos de trabajo
  chargueWorkplace() {
    this.workplaceGroupService
      .getWorkplaces(this.#businessService.business())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          this.workplaceGroups.push({
            workplaceid: 0,
            name: '-- Por defecto --',
            description: 'description',
            id: 0,
          });
          if (resp.code === 10000) {
            this.workplaceGroups = resp.reply || [];
          }
        },
      });
  }

  chargueTypeJobs() {
    this.workplaceTypeService
      .getWorkplaces(this.data.businessId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.ptypeJobs = resp.reply || [];
            let uniqueJobs: TypeOfJob[] = [];

            if (this.issParking() === 1) {
              uniqueJobs = this.ptypeJobs.filter(
                item => item.name === 'PARQUEO'
              ) as TypeOfJob[];
            } else {
              uniqueJobs = this.ptypeJobs.filter(
                item => item.name !== 'PARQUEO'
              ) as TypeOfJob[];
            }

            this.ptypeJobs = uniqueJobs;
            this.ptypeJobs = this.ptypeJobs.filter(
              (job, index, array) =>
                array.findIndex(item => item.name === job.name) === index
            );
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  clearForm() {
    this.buildForm();
  }
}
